import { camelCaseToWords } from "../../helper";

export function filterPermissions(menuData, permissionList, permission) {
  const levels = ["markets", "brands", "clients", "companies"];
  const foundPath = findKeyWithPath({ companies: [menuData] }, levels[permission.level], permission);
  const permissionName = findPermission(permission.permissionId, permissionList);
  return { ...permission, name: foundPath, permissionName: permissionName };
}

export function findKeyWithPath(obj, keyToFind, permission, currentPath = []) {
  for (var key in obj) {
    if (key === keyToFind) {
      let foundPath = obj[key].find(item => item._id === permission.relationId);
      if (foundPath) {
        return [...currentPath, (foundPath.clientName || foundPath.name)].join(' - ');
      }
    }
    if (typeof obj[key] === 'object') {
      if (Array.isArray(obj[key])) {
        for (var i = 0; i < obj[key].length; i++) {
          var result = findKeyWithPath(obj[key][i], keyToFind, permission, [...currentPath, (obj[key][i].clientName || obj[key][i].name)]);
          if (result !== undefined) {
            return result;
          }
        }
      }
    }
  }
}

export function findPermission(id, permissionList) {
  const foundPermission = permissionList.find(item => item._id === id);
  if (foundPermission) {
    return camelCaseToWords(foundPermission.name);
  }
};